import { deepPurple } from '@mui/material/colors';
import { Box, Stack, Button, Typography } from '@mui/material';

import { useResponsive } from 'src/hooks/use-responsive';

import { BRAND_COLOR } from 'src/theme/core';

interface Props {
  setOpenDemoForm: (value: boolean) => void;
}
export const IntroAssignGradeAuto = ({ setOpenDemoForm }: Props) => {
  const deepPurpleColor = deepPurple.A200;
  const lgDown = useResponsive('down', 'lg');
  const mdDown = useResponsive('down', 'md');

  return (
    <Stack
      direction={mdDown ? 'column' : 'row'}
      alignItems="center"
      minHeight={470}
      py={5}
      spacing={8}
      justifyContent="space-between"
    >
      <Stack alignItems="start" flex={mdDown ? 1 : 0.45} height="100%">
        <Typography
          fontFamily='"Shantell Sans Light", sans-serif'
          sx={{ color: deepPurpleColor, mb: 1 }}
          fontSize={18}
          fontWeight="medium"
        >
          Phần mềm quản lý trung tâm thế hệ mới
        </Typography>
        <Typography
          variant="h2"
          sx={{
            mb: 2.5,
            maxWidth: {
              xs: 260,
              sm: '100%',
              md: 360,
              lg: 600,
              xl: 600,
            },
          }}
        >
          Giao & chấm bài tự động với AI
        </Typography>
        <Typography fontFamily='"Plus Jakarta Sans", sans-serif' fontSize={18} mb={3}>
          Giao bài linh hoạt theo lớp, nhóm hoặc từng học viên - Cài đặt thời gian làm bài và thời
          hạn nộp - Giới hạn số lần làm bài và điểm tối thiểu - Chấm điểm tự động với AI.
        </Typography>
        <Typography variant="h6" fontWeight="bold" mb={4}>
          “Tất cả trong một nền tảng duy nhất”
        </Typography>
        <Stack direction="row" alignItems="center" spacing={0.8}>
          <Button
            size="large"
            onClick={() => setOpenDemoForm(true)}
            sx={{
              background: BRAND_COLOR,
              color: 'white',
              '&:hover': {
                background: BRAND_COLOR,
                opacity: 0.9,
              },
              minWidth: 124,
            }}
          >
            Đăng ký Demo
          </Button>
          <Typography variant="body1" sx={{ maxWidth: 280 }} fontWeight={400}>
            Để trải nghiệm cách giao & chấm bài tự động kiểu mới với CenterUp
          </Typography>
        </Stack>
      </Stack>
      <Stack position="relative" flex={0.55}>
        <Box
          component="img"
          alt="gradientbg1"
          src="/assets/sub-pages/gradient1.png"
          position="absolute"
          zIndex={-1000}
          right={lgDown ? 200 : 200}
          top={lgDown ? -100 : -150}
          sx={{
            backgroundSize: 'cover',
          }}
        />
        <Box
          component="img"
          alt="gradientbg2"
          src="/assets/sub-pages/gradient1.png"
          position="absolute"
          zIndex={-1000}
          right={20}
          height={200}
          top={-60}
          width={560}
        />
        <Box
          alignSelf={mdDown ? 'center' : 'end'}
          component="img"
          alt="list-class"
          src="/assets/sub-pages/lms/assign-grade-auto/intro.png"
          zIndex={2}
          right={0}
          top={120}
        />
      </Stack>
    </Stack>
  );
};
